module.exports = __webpack_public_path__ + "static/media/rotate.a8129d86.svg";